import React from "react";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContextProvider";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import { routesConfig } from "./config/routesConfig.js";
import ApiClientConfigurator from "./components/ApiClientConfigurator.jsx";
import "react-datetime/css/react-datetime.css";
import GoogleAnalytics from "./components/cookie/GoogleAnalytics.jsx";
import CookieConsent from "./components/cookie/CookieConsent.jsx";

function App() {
	// const [gaActive, setGaActive] = useState(localStorage.getItem("cookie_consent") === "true");

	return (
		<AuthProvider>
			{/* {gaActive && <GoogleAnalytics />} *
			 <CookieConsent onAccept={() => setGaActive(true)} /> */}
			<GoogleAnalytics />
			<CookieConsent />
			<Router>
				<ToastContainer style={{ zIndex: 9999 }} />
				<ApiClientConfigurator />
				<Routes>
					{routesConfig.map((route, index) => (
						<Route
							key={index}
							path={route.route}
							element={
								route.requiresAuth ? (
									<ProtectedRoute requiredLevel={route.minLevel}>
										<route.component {...route.props} />
									</ProtectedRoute>
								) : (
									<route.component {...route.props} />
								)
							}
						/>
					))}
				</Routes>
			</Router>
		</AuthProvider>
	);
}

export default App;
